import { render, staticRenderFns } from "./DataReportOverviewCharts.vue?vue&type=template&id=2ba09ffe&scoped=true"
import script from "./DataReportOverviewCharts.vue?vue&type=script&lang=js"
export * from "./DataReportOverviewCharts.vue?vue&type=script&lang=js"
import style0 from "./DataReportOverviewCharts.vue?vue&type=style&index=0&id=2ba09ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba09ffe",
  null
  
)

export default component.exports